import standTypeFilterHelper from "./stand-type-filter-helper";

const StandHelpers = {
    typeFilter : standTypeFilterHelper
}

export default StandHelpers;